<script type="text/javascript">
  export default {
    props: {
      theme: {
        type: String,
        default: '',
      },
    },
    computed: {
      classModifiers() {
        return {
          'account-form-loader': true,
          [`account-form-loader--${this.theme}`]: this.theme,
        };
      },
    },
  };
</script>

<template>
  <div class="account-form-loader">
    <template v-if="theme === 'details'">
      <div class="account-form-loader__section">
        <div class="account-form-loader__section-title"></div>
        <div class="account-form-loader__section-row">
          <div class="account-form-loader__section-col-1"></div>
          <div class="account-form-loader__section-col-2"></div>
        </div>
        <div class="account-form-loader__section-row">
          <div class="account-form-loader__section-col-1"></div>
          <div class="account-form-loader__section-col-2"></div>
        </div>
        <div class="account-form-loader__section-row">
          <div class="account-form-loader__section-col-1"></div>
          <div class="account-form-loader__section-col-2"></div>
        </div>
        <div class="account-form-loader__section-row">
          <div class="account-form-loader__section-col-1"></div>
          <div class="account-form-loader__section-col-2"></div>
        </div>
      </div>
      <div class="account-form-loader__section">
        <div class="account-form-loader__section-title"></div>
        <div class="account-form-loader__section-button"></div>
      </div>
      <div class="account-form-loader__section">
        <div class="account-form-loader__section-title"></div>
        <br><br><br>
        <div class="account-form-loader__section-button"></div>
        <div class="account-form-loader__section-button"></div>
        <div class="account-form-loader__section-button"></div>
      </div>
    </template>
    <template v-if="theme === 'withdraw'">
      <div class="account-form-loader__alert"></div>
      <div class="account-form-loader__balance"></div>
      <div class="account-form-loader__input"></div>
      <div class="account-form-loader__line"></div>
      <div class="account-form-loader__button"></div>
    </template>
    <template v-if="theme === 'deposit'">
      <div class="row-x">
        <div class="small-12 medium-4 column">
          <div class="account-form-loader__block"></div>
        </div>
        <div class="small-12 medium-8 column">
            <div class="row-x">
              <div class="small-4 column">
                <div class="account-form-loader__block"></div>
              </div>
              <div class="small-4 column">
                <div class="account-form-loader__block"></div>
              </div>
              <div class="small-4 column">
                <div class="account-form-loader__block"></div>
              </div>
            </div>
        </div>
      </div>
      <div class="row-xy">
        <div class="small-12 column">
          <div class="account-form-loader__block"></div>
        </div>
      </div>
      <div class="row-xy">
        <div class="small-12 column">
          <div class="account-form-loader__block"></div>
        </div>
      </div>
      <div class="row-x">
        <div class="small-4 column">
          <div class="account-form-loader__block"></div>
        </div>
        <div class="small-4 column">
          <div class="account-form-loader__block"></div>
        </div>
        <div class="small-4 column">
          <div class="account-form-loader__block"></div>
        </div>
      </div>
      <div class="row-xy">
        <div class="small-12 column">
          <div class="account-form-loader__block"></div>
        </div>
        <div class="small-6 column">
          <div class="account-form-loader__block"></div>
        </div>
        <div class="small-6 column">
          <div class="account-form-loader__block"></div>
        </div>
      </div>
      <div class="row-x">
        <div class="small-12 column">
          <div class="account-form-loader__block"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss">
  .account-form-loader {
    @import '~styles/settings';

    background: $white;
    padding: 10px;

    &__alert {
      @include text-line(100%, 45px);
    }

    &__balance {
      margin: 15px auto;

      @include text-line(140px, 70px);
    }

    &__input {
      @include text-line(100%, 62px);
    }

    &__line {
      margin: 10px 0 80px;

      @include text-line(100%, 35px);
    }

    &__button {
      @include text-line(100%, 50px);
    }

    &__block {
      @include text-line(100%, 42px);

      margin: 10px 0;
    }

    &__section {
      &-title {
        margin-top: 10px;

        @include text-line(100px, 15px);
      }

      &-button {
        margin: 10px 0;

        @include text-line(100%, 42px);
      }

      &-row {
        display: flex;
        justify-content: space-between;
        padding: 20px 0;
        border-bottom: 1px solid $grey2;
      }

      &-col-1 {
        @include text-line(110px, 9px);
      }

      &-col-2 {
        @include text-line(40px, 9px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/AccountFormLoader.vue